import { render } from "./TheFeedback.vue?vue&type=template&id=21e61a96"
import script from "./TheFeedback.vue?vue&type=script&lang=js"
export * from "./TheFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__